/* Redux Imports */

import { ObjectId } from "bson";
import { CreateNewViewThunk } from "../redux-magic/store";

const openViewTrackingWebsocket = (
	dispatch: Function,
	ws: any,
	view_time_spent_id: string | ObjectId,
	viewUpdated: boolean,
	setViewUpdated: any,
	entity_creator_user_id: string | ObjectId,
	viewed_entity_type: string,
	viewed_entity_id: string | ObjectId,
	viewer_is_logged_in: boolean,
	viewer_is_business_profile: boolean,
	viewer_user_id: string | ObjectId,
	viewer_business_profile_id: string | ObjectId,
	viewer_session_id: string | ObjectId,
	viewer_ip_address: string | null,
	viewer_user_agent: string | null,
	source: string,
) => {
	/*

		& Let's create a new view in DB by dispatching the CreateNewViewThunk.

	*/

	if (!viewUpdated) {
		dispatch(
			CreateNewViewThunk({
				entity_creator_user_id: entity_creator_user_id,
				viewed_entity_type: viewed_entity_type,
				viewed_entity_id: viewed_entity_id,
				viewer_is_logged_in: viewer_is_logged_in,
				viewer_is_business_profile: viewer_is_business_profile,
				viewer_user_id: viewer_user_id,
				viewer_business_profile_id: viewer_business_profile_id,
				viewer_session_id: viewer_session_id,
				viewer_ip_address: viewer_ip_address,
				viewer_user_agent: viewer_user_agent,
				source: source,
			}),
		);
		setViewUpdated(true);
	}

	if (viewUpdated && view_time_spent_id !== "") {
		/*

			& Now, let's open a websocket to views.beegru.com to track the time spent on the page.

		*/

		ws.current = new WebSocket("wss://views.beegru.com?viewTimeSpentId=" + view_time_spent_id);

		/*

			& Let's add the onOpen event listener.

		*/

		ws.current.addEventListener("open", function open() {
			console.log("View tracking websocket connection opened");
		});

		ws.current.addEventListener("message", function incoming(event: any) {
			// console.log(event.isTrusted, "event");
			// switch (JSON.parse(event.data.toString()).action.toString()) {
			// 	case undefined:
			// 		console.log("%c ❤️~View~Heartbeat~❤️", "color: #FF0000");
			// 		break;
			// 	default:
			// 		console.error("Unknown message received from server: ", event.data);
			// 		break;
			// }
		});

		ws.current.addEventListener("error", function error() {
			console.log("View tracking websocket error");
		});

		/*

    		& Let's register a setInterval to send a heartbeat to the server and keep the websocket alive.

  		*/

		const heartbeat = setInterval(() => {
			ws?.current?.send(
				JSON.stringify({
					viewTimeSpentId: view_time_spent_id,
				}),
			);
		}, parseInt("10000"));

		return () => {
			clearInterval(heartbeat);
		};
	}
};

export default openViewTrackingWebsocket;
